import { render } from "./CustomTokenCreate.vue?vue&type=template&id=44676460&scoped=true"
import script from "./CustomTokenCreate.vue?vue&type=script&lang=js"
export * from "./CustomTokenCreate.vue?vue&type=script&lang=js"

import "./CustomTokenCreate.vue?vue&type=style&index=0&id=44676460&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44676460"]])

export default __exports__